import React from 'react';
import { Calendar } from 'lucide-react';
interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function DatePicker({
  label,
  error,
  helperText,
  className = '',
  ...props
}: DatePickerProps) {
  return <div className="w-full space-y-1.5" data-id="element-1163">
      {label && <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700" data-id="element-1164">
          {label} {props.required && <span className="text-red-500" data-id="element-1165">*</span>}
        </label>}
      <div className="relative" data-id="element-1166">
        <input type="date" className={`
            flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-1167" />
        <Calendar className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" data-id="element-1168" />
      </div>
      {helperText && !error && <p className="text-xs text-gray-500" data-id="element-1169">{helperText}</p>}
      {error && <p className="text-xs text-red-500 font-medium" data-id="element-1170">{error}</p>}
    </div>;
}